import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

function Copyright(props) {
  const { title, classes } = props;
  return (
    <Typography variant="body2" color="textSecondary" align="center" className={classes.copyright}>
      {'© '}
      {new Date().getFullYear()}{' '}
      <Link color="inherit" href="https://cybros.dev/" className={classes.link}>
        {title}
      </Link>
      {'. All Rights Reserved.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(10, 0, 5),
    background: 'linear-gradient(135deg, #0a1628 0%, #1a365d 100%)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      background: 'linear-gradient(90deg, #00d4aa, #667eea)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: '800px',
      height: '800px',
      transform: 'translate(-50%, -50%)',
      background: 'radial-gradient(circle, rgba(0, 212, 170, 0.05) 0%, transparent 60%)',
      animation: 'aiPulse 6s ease-in-out infinite',
      pointerEvents: 'none',
    },
  },
  tagline: {
    color: '#ffffff',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontWeight: 600,
    fontSize: '1.5rem',
    marginBottom: theme.spacing(2),
    position: 'relative',
    zIndex: 1,
  },
  description: {
    color: 'rgba(255, 255, 255, 0.7)',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: '1.1rem',
    marginBottom: theme.spacing(4),
    position: 'relative',
    zIndex: 1,
  },
  copyright: {
    color: 'rgba(255, 255, 255, 0.5)',
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    fontSize: '1rem',
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(4),
    borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    position: 'relative',
    zIndex: 1,
  },
  link: {
    color: '#00d4aa',
    textDecoration: 'none',
    transition: 'all 0.3s ease',
    '&:hover': {
      color: '#ffffff',
      textDecoration: 'none',
      textShadow: '0 0 20px rgba(0, 212, 170, 0.5)',
    },
  },
}));

export default function Footer(props) {
  const classes = useStyles();
  const { themeTitle } = props;

  return (
    <footer className={classes.root}>
      <Container maxWidth="lg">
        <Grid container justify="center">
          <Grid item xs={12} sm={12}>
            <Typography align="center" className={classes.tagline}>
              Building the Future with AI-Powered Solutions
            </Typography>
            <Typography align="center" className={classes.description}>
              Transforming businesses through innovative technology and intelligent software development.
            </Typography>
          </Grid>
        </Grid>
        <Copyright title={themeTitle} classes={classes} />
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  description: PropTypes.string,
  themeTitle: PropTypes.string,
};
